import React from 'react';
import styled from 'styled-components';

import {GetCardTypeForBody} from '../../../../../../../util/utils';
import AresSpecialBodyContainer from '../../AresSpecialBodyContainer';
import ControlAttributes from './ControlAttributes';

export default function ControlAttributesBody(props) {
	const {
		bodyContent,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		...extraProps
	} = props;
	const formBodyBorder = GetCardTypeForBody(bodyContent);

	return (
		<Wrapper className={`SectionBodyWrapper ControlAttributes ${formBodyBorder}`}>
			<AresSpecialBodyContainer
				bodyContent={bodyContent}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				updateBodyOptions={updateBodyOptions}
				getBodiesBySectionId={getBodiesBySectionId}
				isSnapshotView={isSnapshotView}
				showDescription={false}
				{...extraProps}
			>
				<ControlAttributes />
			</AresSpecialBodyContainer>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
`;
